// extracted by mini-css-extract-plugin
export default {"Cacao":"#645B57","button":"G67e611 G5e65f6 Ga51246 Gcf9c37","top-right":"Gff04f1"};